import { faCheckDouble, faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Card, Col, OverlayTrigger, Popover, Row, Tab, Table, Tabs } from 'react-bootstrap';
import { MdDelete } from 'react-icons/md';
import { SiImessage } from 'react-icons/si';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Pagination from '../../Pagination';
import ChatComponent from '../ChatComponent';
import './CandidateDashboard.css';
import DashboardLayout from './DashboardLayout';
import GlobalCandidateSettings from './GlobalCandidateSettings';
import { FaFileAlt, FaLink, FaQuestionCircle, FaUserNinja } from 'react-icons/fa';

const MyApplication = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const userName = location.state?.userName;
  const userId = location.state?.userId;
  // Get applicationStatus from location.state or default to null
  const applicationStatus = location.state?.applicationStatus;

  // Set the initial key (active tab) based on the applicationStatus
  const [key, setKey] = useState(applicationStatus ? 'shortlisted' : 'all');
  const [applications, setApplications] = useState([]);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('All'); // Filter state
  const [resumeNames, setResumeNames] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20); // Default page size
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false); // State to manage loading
  const navigate = useNavigate();

  useEffect(() => {
    fetchResumeNames();
  }, [applications]);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handlePageClick = (data) => {
    setPage(data.selected);
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };
  const handleFilterChange = (event) => {
    setFilter(event.target.value);
    setPage(0); // Reset to the first page
  };
  const [sortedColumn, setSortedColumn] = useState(null); // Track the currently sorted column
  const [sortOrder, setSortOrder] = useState(' '); // Track the sort order (asc or desc)

  // useEffect(() => {
  //   if (applicationStatus) {
  //     fetchApplicationsByStatus('Short');
  //   }
  //   else if (search && !applicationStatus) {
  //     fetchApplicationBySearch(search);

  //   } else {
  //     fetchApplications();
  //   }
  // }, [applicationStatus, page, pageSize, search, sortOrder, sortedColumn, userId, filter]);
  // useEffect to fetch data based on the active tab (key)
  useEffect(() => {
    if (key === 'shortlisted') {
      fetchApplicationsByStatus('Shortlisted');
    } else if (search) {
      fetchApplicationBySearch(search);
    } else {
      fetchApplications();
    }
  }, [key, page, pageSize, search, sortOrder, sortedColumn, userId, filter]); // Depend on `key` and other states


  const fetchApplications = async () => {
    try {
      setLoading(true);
      const params = {
        userId: userId,
        page: page,
        pageSize: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder,
        filter: filter === 'All' ? undefined : filter, // Add filter to params
      };

      const response = await axios.get(`${BASE_API_URL}/applicationsPagination`, { params });

      if (sortedColumn) {
        params.sortBy = sortedColumn;
        params.sortOrder = sortOrder;
      }

      setApplications(response.data.content);
      setTotalPages(response.data.totalPages);
      //setApplicationStatus('');
    } catch (error) {
      console.error('Error fetching applications:', error);
    } finally {
      setLoading(false);
    }

  };

  const fetchApplicationsByStatus = async (applicationStatus) => {
    try {
      const params = {
        searchStatus: search,
        applicationStatus: applicationStatus,
        userId: userId,
        page: page,
        pageSize: pageSize,
        filter: filter === 'All' ? undefined : filter, // Add filter to params
      };

      if (sortedColumn) {
        params.sortBy = sortedColumn;
        params.sortOrder = sortOrder;
      }

      const response = await axios.get(`${BASE_API_URL}/applicationsByStatusAndSearch`, { params });
      setApplications(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching applications by status:', error);
    }
  };

  const fetchApplicationBySearch = async (search) => {
    try {
      setLoading(true);
      const params = {
        searchStatus: search,
        userId: userId,
        page: page,
        pageSize: pageSize,
        filter: filter === 'All' ? undefined : filter, // Add filter to params
      };

      if (sortedColumn) {
        params.sortBy = sortedColumn;
        params.sortOrder = sortOrder;
      }

      const response = await axios.get(`${BASE_API_URL}/applicationsBySearch`, { params });
      setApplications(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching applications by search:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchResumeNames = async () => {
    try {
      // Create an array of promises
      const promises = applications.map(application =>
        getResumeName(application.resumeId).then(resumeInfo => ({
          id: application.resumeId,
          data: resumeInfo
        }))
      );

      // Wait for all promises to resolve
      const results = await Promise.all(promises);

      // Convert results array into an object
      const names = {};
      results.forEach(({ id, data }) => {
        names[id] = data;
      });

      setResumeNames(names);
    } catch (error) {
      console.error('Error fetching resume names:', error);
    }
  };



  const handleSort = (column) => {
    let order = 'asc';
    if (sortedColumn === column) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    setSortedColumn(column);
    setSortOrder(order);
  };

  const getResumeName = async (resumeId) => {
    try {
      const response = await axios.get(`${BASE_API_URL}/getResumeMessageById?resumeId=${resumeId}`);
      return {
        message: response.data.message,
        fileType: response.data.fileType
      };
    } catch (error) {
      console.error('Error fetching resume name:', error);
      return {
        message: 'Unknown',
        fileType: 'unknown'
      };
    }
  };




  const [chats, setChats] = useState([]); // Initialize chats as an empty array
  const [jobStatuses, setJobStatuses] = useState({});
  const [unreadMessages, setUnreadMessages] = useState([]); // State to track unread messages

  useEffect(() => {
    const fetchStatuses = async () => {
      const statuses = {};
      const chats = []; // Initialize chats as an array
      const unread = {}; // Initialize unread messages state

      for (const application of applications) {
        try {
          const status = await getJobStatus(application.jobId);
          const chat = await fetchChat(application.applicationId);
          const countUnread = await fetchCountUnreadMessage(application.applicationId);
          statuses[application.applicationId] = status;
          chats.push(chat); // Push chat into the array
          unread[application.applicationId] = countUnread;

        } catch (error) {
          console.error('Error fetching job status:', error);
          statuses[application.id] = 'Unknown';
        }
      }
      setJobStatuses(statuses);
      setChats(chats); // Set chats as the array of fetched chats
      setUnreadMessages(unread); // Set unread messages state
    };
    fetchStatuses();
  }, [applications]);

  const getJobStatus = async (jobId) => {
    if (jobId === 0) {
      return 'Job not available';
    } else {
      try {
        const response = await axios.get(`${BASE_API_URL}/getJob?jobId=${jobId}`);

        if (response.data.jobCategory === "evergreen") {
          return "Evergreen";
        } else {
          return response.data.jobStatus ? 'Active' : 'Not Active';
        }
      } catch (error) {
        console.error("Error fetching job status:", error);
        throw error;
      }
    }
  };

  const renderJobStatus = (applicationId) => {
    return jobStatuses[applicationId] || 'Loading...';
  };


  const fetchCountUnreadMessage = async (applicationId) => {
    try {
      const response = await axios.get(`${BASE_API_URL}/fetchCountUnreadMessageForCandidateByApplicationId?applicationId=${applicationId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching chats:", error);
    }
  }

  const fetchChat = async (applicationId) => {

    try {
      const response = await axios.get(`${BASE_API_URL}/fetchChatByApplicationId?applicationId=${applicationId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching chats:", error);
    }
  };



  const handleDelete = async (applicationId) => {

    try {
      const confirmDelete = await axios.delete(`${BASE_API_URL}/deleteApplicationByApplicationId?applicationId=${applicationId}`);
      if (confirmDelete.data) {
        fetchApplications();
      }
    } catch {
      // console.log("Unable to delete appliction")
    } // Show a confirmation dialog before deletion

  };


  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;


  // State to track if the ChatComponent is open
  const [isChatOpen, setIsChatOpen] = useState(false);

  const [chatData, setChatData] = useState({
    applicationId: null,
    candidateId: null,
    hrId: null,
  });

  // Function to handle chat icon click
  const toggleChat = (application) => {
    // Mark messages as read
    axios.put(`${BASE_API_URL}/markHRMessagesAsRead?applicationId=${application.applicationId}`);

    const unread = {}; // Initialize unread messages state
    try {

      const countUnread = fetchCountUnreadMessage(application.applicationId);

      unread[application.applicationId] = countUnread;

    } catch (error) {
      console.error('Error fetching job status:', error);
    }
    setUnreadMessages(unread); // Set unread messages state

    // Set the chat data for the clicked application
    setChatData({
      applicationId: application.applicationId,
      candidateId: application.candidateId,
      hrId: application.hrId,
    });
    // Toggle the visibility of the ChatComponent
    setIsChatOpen(!isChatOpen);
  };


  
  // State to manage the visibility of the filter options
  const [showFilter, setShowFilter] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  // Function to handle filter visibility
  const showFilterOption = (application) => {
    // If the jobRole is null or if job status is "Evergreen", show the filter for that specific application
    if (application.jobRole == null || renderJobStatus(application.applicationId) === "Evergreen") {
      setSelectedApplication(application);  // Track the clicked application
      setShowFilter(true);  // Show the filter
      fetchFilterOptions(application.applicationId);
    } else {
      toggleChat(application);
    }
  };

  const [filterOptions, setFilterOptions] = useState([]);
  // Fetch HR names (user data)
  const fetchFilterOptions = (applicationId) => {
    axios
      .get(`${BASE_API_URL}/fetchHRnames`, {
        params: {
          applicationId: applicationId,
          userId: userId,
        },
      })
      .then((response) => {
        // console.log('Fetched HR names:', response.data);
        setFilterOptions(response.data); // Update the state with HR list
      })
      .catch((error) => {
        console.error('Error fetching HR names:', error);
      });
  };

  // Handle the onClick event for the label
  const handleLabelClick = (application, userId) => {
    setShowFilter(false);
    setSelectedApplication(null);
    application.hrId = userId;
    // console.log(`HR user with ID ${userId} clicked!`);
    // console.log(application);
    toggleChat(application);
    // Add any other logic you'd like to trigger when the label is clicked
  };


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll smoothly to top
  }, [page]); // Whenever page state changes


  const customTabHeader = (title, icon) => (
    <div className="d-flex align-items-center">
      <span className="me-2">
        {/* <i className={icon} /> */}
        {icon}
      </span>
      <span class="fs-6 fw-bold">{title}</span>
    </div>
  );


  const renderHRPopover = (application) => (
    <Popover id={`popover-${application.applicationId}`} style={{ minWidth: '220px' }}>
      <Popover.Header as="h3" className="d-flex justify-content-between align-items-center">
        HR Names List
        <button
          type="button"
          className="btn-close btn-close-white"
          aria-label="Close"
          onClick={() => setShowFilter(false)}
          style={{ filter: 'invert(0.5)' }} // make close button visible on light bg
        />
      </Popover.Header>
      <Popover.Body>
        {filterOptions && filterOptions.length > 0 ? (
          <ul className="list-group list-group-flush">
            {filterOptions.map((user) =>
              user?.userId ? (
                <li
                  key={user.userId}
                  className="list-group-item list-group-item-action"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleLabelClick(application, user.userId)}
                >
                  {user.userName}
                </li>
              ) : null
            )}
          </ul>
        ) : (
          <p className="text-muted mb-0">No HR names available</p>
        )}
      </Popover.Body>
    </Popover>
  );
const getResumeIcon = (fileType) => {
  switch (fileType) {
    case 'brief':
      return <FaUserNinja className="me-2 text-primary" title="Brief" />;
    case 'file':
      return <FaFileAlt className="me-2 text-success" title="File" />;
    case 'link':
      return <FaLink className="me-2 text-info" title="Link" />;
    default:
      return <FaQuestionCircle className="me-2 text-muted" title="Unknown Type" />;
  }
};
  return (
    <DashboardLayout>
      <div className="main-content">
        <Row className="d-flex justify-content-between align-items-center" style={{ marginBottom: '20px' }}>
          <Col xs="auto">
            <h2 className='text-start' style={{ paddingLeft: '12px', marginBottom: 0 }}>My Applications</h2>
          </Col>
          <Col xs="auto">
            <GlobalCandidateSettings userId={userId} />

          </Col>
        </Row>
        <Row>
          <Col className='filter-action' style={{ paddingTop: '10px', marginLeft: '12px', marginRight: '12px' }}>
            <Tabs
              id="application-tabs"
              activeKey={key}
              onSelect={(k) => setKey(k)}  // Change active tab on select
              className="mb-3"
            >
              <Tab eventKey="all" title={customTabHeader("All Applications ", <FontAwesomeIcon icon={faList} />)} >
                {/* Automatically fetch data when this tab is selected */}
              </Tab>

              <Tab eventKey="shortlisted" title={customTabHeader("Shortlisted Applications ", <FontAwesomeIcon icon={faCheckDouble} />)} >
                {/* Automatically fetch data when this tab is selected */}
              </Tab>
            </Tabs>
          </Col>
        </Row>
        <Row>
          <Col className="filter-action" md={4} style={{ paddingTop: '10px', marginLeft: '12px', marginRight: '12px' }}>
            <label htmlFor="status" className="form-label" style={{ color: '#6c5b7b' }}>
              Filter by Actions:
            </label>
            <select
              id="status"
              className="form-select form-select-sm fs-6"
              style={{
                borderColor: '#6c5b7b',
                borderRadius: '6px',
                height: '40px', // Same height as the input
                width: '100%', // Full width to match input
              }}
              onChange={handleFilterChange}
              value={filter}
            >
              <option value="all">All</option>
              <option value="Regular Jobs">Regular Jobs</option>
              <option value="Dream Applications">Dream Application</option>
              <option value="EverGreen Jobs">EverGreen Jobs</option>
            </select>
          </Col>

          <Col md={3} className="d-flex align-items-left" style={{ paddingTop: '30px' }}>
            {/* Search Bar */}
            <div className="search-bar" style={{ flex: 1 }}>
              <input
                style={{
                  borderColor: '#6c5b7b',
                  borderRadius: '6px',
                  height: '40px', // Match the height of the select
                  width: '100%', // Full width
                  padding: '0 10px', // Add horizontal padding for text
                }}
                type="text"
                name="search"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
          </Col>
        </Row>

        <br />
        <div>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <div className="spinner-bubble spinner-bubble-primary m-5" />
              <span>Loading...</span>
            </div>
          ) : applications.length === 0 ? (
            <div className="d-flex justify-content-center align-items-center">
              <span>No applications yet</span>
            </div>
          ) : (
            <>
              <Card body>
                {/* <Card.Title>Light hoverable Table</Card.Title>

                <p>
                  Add <code>.table-hover</code> to enable a hover state on table rows within a{" "}
                  <code>&lt;tbody&gt;</code>.
                </p>    className="text-center" */}
                <div className="table-details-list table-wrapper">
                  <Table hover responsive >
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          onClick={() => handleSort("companyName")}
                          style={{ cursor: "pointer" }}
                        >
                          Company Name{" "}
                          <span>
                            <span
                              style={{
                                color:
                                  sortedColumn === "companyName" && sortOrder === "asc"
                                    ? "black"
                                    : "gray",
                              }}
                            >
                              ↑
                            </span>{" "}
                            <span
                              style={{
                                color:
                                  sortedColumn === "companyName" && sortOrder === "desc"
                                    ? "black"
                                    : "gray",
                              }}
                            >
                              ↓
                            </span>
                          </span>
                        </th>
                        <th
                          scope="col"
                          onClick={() => handleSort("jobRole")}
                          style={{ cursor: "pointer" }}
                        >
                          Job Title{" "}
                          <span>
                            <span
                              style={{
                                color:
                                  sortedColumn === "jobRole" && sortOrder === "asc"
                                    ? "black"
                                    : "gray",
                              }}
                            >
                              ↑
                            </span>{" "}
                            <span
                              style={{
                                color:
                                  sortedColumn === "jobRole" && sortOrder === "desc"
                                    ? "black"
                                    : "gray",
                              }}
                            >
                              ↓
                            </span>
                          </span>
                        </th>
                        <th
                          scope="col"
                          onClick={() => handleSort("appliedOn")}
                          style={{ cursor: "pointer" }}
                        >
                          Applied On{" "}
                          <span>
                            <span
                              style={{
                                color:
                                  sortedColumn === "appliedOn" && sortOrder === "asc"
                                    ? "black"
                                    : "gray",
                              }}
                            >
                              ↑
                            </span>{" "}
                            <span
                              style={{
                                color:
                                  sortedColumn === "appliedOn" && sortOrder === "desc"
                                    ? "black"
                                    : "gray",
                              }}
                            >
                              ↓
                            </span>
                          </span>
                        </th>
                        <th scope="col">Resume Profile</th>
                        <th scope="col">Job Status</th>
                        <th
                          scope="col"
                          onClick={() => handleSort("applicationStatus")}
                          style={{ cursor: "pointer" }}
                        >
                          Action{" "}
                          <span>
                            <span
                              style={{
                                color:
                                  sortedColumn === "applicationStatus" && sortOrder === "asc"
                                    ? "black"
                                    : "gray",
                              }}
                            >
                              ↑
                            </span>{" "}
                            <span
                              style={{
                                color:
                                  sortedColumn === "applicationStatus" && sortOrder === "desc"
                                    ? "black"
                                    : "gray",
                              }}
                            >
                              ↓
                            </span>
                          </span>
                        </th>
                        <th scope="col">Chat</th>
                        <th scope="col">Delete</th>
                      </tr>
                    </thead>

                    <tbody>
                      {applications.map((application, index) => (

                        <tr key={index}>
                          <td>{application.companyName}</td>
                          <td>
                            {application.isSearchAndShortlist
                              ? "SearchAndShortlist"
                              : application.jobRole || "Dream application"}
                          </td>
                          <td>{application.appliedOn}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              {getResumeIcon(resumeNames[application.resumeId]?.fileType)}
                              <span>{resumeNames[application.resumeId]?.message || 'Loading...'}</span>
                            </div>
                          </td>
                          <td
                            style={{
                              color:
                                renderJobStatus(application.applicationId) === "Evergreen"
                                  ? "green"
                                  : "black",
                            }}
                          >
                            {renderJobStatus(application.applicationId)}
                          </td>

                          <td>{application.applicationStatus}</td>

                          <td>
                            {chats[index] && chats[index].length > 0 ? (
                              <div style={{ position: 'relative', display: 'inline-block' }}>
                                {unreadMessages[application.applicationId] > 0 && (
                                  <span
                                    style={{
                                      position: 'absolute',
                                      top: '-5px',
                                      right: '-15px',
                                      backgroundColor: 'red',
                                      color: 'white',
                                      borderRadius: '50%',
                                      width: '20px',
                                      height: '20px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontSize: '12px',
                                      fontWeight: 'bold',
                                      zIndex: 1,
                                    }}
                                  >
                                    {unreadMessages[application.applicationId]}
                                  </span>
                                )}

                                <OverlayTrigger
                                  trigger="click"
                                  placement="left"
                                  rootClose
                                  overlay={
                                    showFilter && selectedApplication?.applicationId === application.applicationId
                                      ? renderHRPopover(application)
                                      : <></>
                                  }
                                  onToggle={(nextShow) => {
                                    if (!nextShow) setShowFilter(false);
                                  }}
                                >
                                  <span style={{ display: 'inline-block' }}>
                                    <SiImessage
                                      size={25}
                                      onClick={() => showFilterOption(application)}
                                      style={{ color: 'green', cursor: 'pointer' }}
                                    />
                                  </span>
                                </OverlayTrigger>
                              </div>
                            ) : (
                              <SiImessage size={25} style={{ color: 'grey', cursor: 'not-allowed' }} />
                            )}
                          </td>

                          <td>
                            <span
                              className="delete cursor-pointer text-danger me-2"
                              onClick={() => {
                                Swal.fire({
                                  title: "Are you sure?",
                                  text: "You won't be able to revert this!",
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonColor: "#3085d6",
                                  cancelButtonColor: "#d33",
                                  confirmButtonText: "Yes, delete it!",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    handleDelete(application.applicationId);
                                  }
                                });
                              }}
                            >
                              <MdDelete className="text-danger" size={18} />
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <Pagination
                  page={page}
                  pageSize={pageSize}
                  totalPages={totalPages}
                  handlePageSizeChange={handlePageSizeChange}
                  isPageSizeDisabled={isPageSizeDisabled}
                  handlePageClick={handlePageClick}
                />
              </Card>
            </>
          )}
        </div>


        {isChatOpen && (
          <ChatComponent
            applicationId={chatData.applicationId}
            candidateId={chatData.candidateId}
            hrId={chatData.hrId}
            userType='Candidate'
            setIsChatOpen={setIsChatOpen}
          />
        )}
      </div>
    </DashboardLayout>
  );
};

export default MyApplication;